<template>
<!--  <label style="margin-left: 5px;font-weight: bold">员工信息:</label>-->
    <el-form style="margin: 25px 45px 0 25px;" :model="leaveData" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="姓名：" required>
            <el-input v-model="leaveData.employee_name" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工号：" required>
            <el-input v-model="leaveData.employee_no" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="部门：" required>
            <el-cascader v-model="leaveData.department_ids" :options="departmentList"
                         :props="optionProps" style="width: 100%" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="假别：">
            <el-input v-model="leaveData.leave_type" disabled>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="年度：">
            <el-input v-model="leaveData.year" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="发放：">
            <el-input v-model="leaveData.days" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="使用：">
            <el-input v-model="leaveData.use_day" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="余额：">
            <el-input v-model="leaveData.balance" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效期：">
            <el-input v-model="leaveData.expiring_date" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
<!--  <label style="margin:0 0 5px 5px;font-weight: bold">使用记录:</label>
  <el-table :data="leaveTable" stripe border height="250" style="width: 98%;font-size: 13px;margin: 5px">
    <el-table-column prop="process_id" label="工作流编号" min-width="150" align="center"/>
    <el-table-column prop="start_time" label="请假开始时间" width="230" align="center"/>
    <el-table-column prop="end_time" label="请假结束时间" width="230" align="center"/>
    <el-table-column prop="use_hours" label="请假小时数" width="110" align="center"/>
    <el-table-column prop="hours_show" label="扣除天数" width="110" align="center"/>
  </el-table>-->
</template>

<script>

export default {
  name: "AttendanceAnnualLeave",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      optionProps: {
        value: 'id',
        label: 'name',
        emitPath:false
      },
      leaveData: {
        employee_no:'',
        department_ids:[]
      },
      departmentList: [],
      leaveTable: []
    };
  },
  methods: {
    //获取部门列表
    async getDepartmentList() {
      this.departmentList = await this.$http('sysUserDepartmentService.getDepartmentData');
    },
    //   回显数据
    async getAnnualLeaveData() {
      let params = {id: this.parentData.id}
      let dbLeave = await this.$http('attendanceLeaveService.getLeaveById', params);
      if (dbLeave) {
        this.leaveData = dbLeave;
        this.leaveData.department_ids = dbLeave.department_ids
      }
      await this.getLeaveType();
      await this.getLeaveTable();
    },
    //   table获取数据
    async getLeaveTable() {
      let params = {
        id: this.parentData.id,
        employee_no:this.leaveData.employee_no,
        expiring_date:this.leaveData.expiring_date,
        leave_type: this.parentData.leave_type
      }
      console.log( "leave_type: ",params)
      let tbLeave = await this.$http('attendanceLeaveService.getLeaveTable', params);
      if (tbLeave) {
        this.leaveTable = tbLeave
      }
    },
    //   获取假别字典
    async getLeaveType() {
      let params = {
        id: this.parentData.id,
        leave_type: this.leaveData.leave_type
      }
      console.log( "123: ",params)
      this.leaveData.leave_type = await this.$http('attendanceLeaveService.getLeaveTypeName', params);
    }
  },
  created() {
    this.getAnnualLeaveData();
    this.getDepartmentList();
  }
}
</script>


<style lang="less" scoped>

</style>
